var utils = {
    generateUUID() {
        return crypto.randomUUID()
    }
}

export default utils